// extracted by mini-css-extract-plugin
module.exports = {"container":"overlay_container__3Wdbd","item":"overlay_item__myixg","bubble":"overlay_bubble__sdY9N","like":"overlay_like__39AQw"};